import { computed, onMounted, onUnmounted, ref } from 'ui.vue3';

export default {
  name: 'MapFilterModalComponent',
  props: [
    'modelValue',
  ],
  emits: ['update:modelValue', 'clear', 'apply'],
  setup(props, {emit}) {

    const rootRef = ref(null);

    const modal = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    })

    const onDocumentClick = (event) => {
      if (!modal.value || !rootRef.value) {
        return;
      }
      if (rootRef.value.contains(event.target)) {
        return;
      }
      if (event.target.closest && event.target.closest('.partners-map-filter-button')) {
        return;
      }
      if (!document.contains(event.target)) {
        return;
      }
      modal.value = false;
    }

    onMounted(() => {
      document.addEventListener('click', onDocumentClick);
    })

    onUnmounted(() => {
      document.removeEventListener('click', onDocumentClick);
    })

    return {
      modal,
      rootRef
    }
  },
  template: `
    <div v-if="modal" ref="rootRef" class="partners-map-filter-modal">
      <button class="partners-map-filter-modal__x" @click="modal = false">
        <img src="/local/templates/new_site_v2/images/parthners_map/close_modal.svg">
      </button>
      <slot />
    </div>
  `,
}
